
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_62033_199)","fill":"#4A4A4A"}},[_c('path',{attrs:{"d":"M2.03 11.45h11.94V3.43H2.03v8.02zm13.44.19a1.31 1.31 0 01-1.31 1.31H1.84a1.31 1.31 0 01-1.31-1.31v-8.4c0-.724.586-1.31 1.31-1.31h12.32c.723 0 1.31.586 1.31 1.31v8.4z"}}),_c('path',{attrs:{"d":"M9.771 11.614a.75.75 0 011.004.06l.05.057 2.24 2.8.045.063a.75.75 0 01-1.165.932l-.05-.057-2.241-2.8-.045-.063a.75.75 0 01.162-.992zM5.225 11.674a.751.751 0 011.12.995l-2.24 2.8a.75.75 0 01-1.17-.938l2.24-2.8.05-.057zM5.01 9.4V7.72a.75.75 0 011.5 0V9.4a.75.75 0 11-1.5 0zM7.25 9.4V6.6a.75.75 0 011.5 0v2.8a.75.75 0 01-1.5 0zM9.49 9.4V5.48a.75.75 0 011.5 0V9.4a.75.75 0 11-1.5 0zM7.25 2.68V1a.75.75 0 011.5 0v1.68a.75.75 0 01-1.5 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_62033_199"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    